import { render } from "./BuscarClienteModal.vue?vue&type=template&id=e4a2f2be&scoped=true"
import script from "./BuscarClienteModal.vue?vue&type=script&lang=js"
export * from "./BuscarClienteModal.vue?vue&type=script&lang=js"

import "./BuscarClienteModal.vue?vue&type=style&index=0&id=e4a2f2be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4a2f2be"]])

export default __exports__